import { CodeBook, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { UserInfo, UserListItem, UserSession, AppUserRole } from "../../models/User";
import { ExportUsersRequest } from "./ExportUsersRequest";
import { SearchUserRequest } from "./SearchUserRequest";

export const getUserSession = async () => {
  return api.get(`user-session`) as Promise<UserSession>;
};

export const getUserInstitutionSession = async (institutionId: number) => {
  return api.get(`user-session-institution/${institutionId}`,
    institutionId) as Promise<UserSession>;
};

const rolesUrlPrefix: string = "roles";
const getUserFromOibUrlPrefix: string = "get-user";

export const searchUsers = async (request: SearchUserRequest) => {
  var result = await (api.get(
    rolesUrlPrefix + "/search-user",
    request
  ) as Promise<PagedResult<UserListItem>>);

  return result;
}

export const getUserFromOibRequest = async (oib: string, firstName: string, lastName: string) => {
  return api.get(
    `${rolesUrlPrefix}/${getUserFromOibUrlPrefix}/${oib}/${firstName}/${lastName}`,
    oib
  ) as Promise<UserInfo>;
}

export const createUserRequest = async (request: UserInfo) => {  
    return api.post(
    rolesUrlPrefix,
    request
  ) as Promise<number>;
};

export const updateUserRequest = async (request: UserInfo) => {  
    return api.put(
    rolesUrlPrefix,
    request
  ) as Promise<void>;
};

export const deleteUserRequest = async (userId: number) => {
  var result = await (api.delete(
    `${rolesUrlPrefix}/user/${userId}`
  ) as Promise<void>);

  return result;
}

export const exportUsers = async (request: ExportUsersRequest) => {
  var result = await (api.download(
    rolesUrlPrefix + "/export-user",
    "get",
    request
  ) as Promise<unknown>);
  return result;
};

export const getASOOUsers = async () => {
  return api.get(
    `${rolesUrlPrefix}/get-asoo-users`
  ) as Promise<AppUserRole[]>;
};

export const getMZOUsers = async () => {
  return api.get(
    `${rolesUrlPrefix}/get-mzo-users`
  ) as Promise<AppUserRole[]>;
};

// export const getNotificationRoles = async () => {
//   return api.get(
//     `${rolesUrlPrefix}/get-notification-roles`
//   ) as Promise<CodeBook[]>;
// };